<template>
  <v-container class="cmpbk black--text" id="reg-container">
    <h2 class="white--text">Volunteer Registration</h2>

    <v-btn small class="mb-4" color="orange" @click="fillDev">
      Dev Fill
    </v-btn>

    <v-stepper v-model="stepcount" non-linear vertical class="py-2 volunteer-stepper">
      <!-- STEP 1 -->
      <v-stepper-step :complete="stepcount > 1" step="1">
        Volunteer Preference
      </v-stepper-step>

      <v-stepper-content step="1" class="pa-0">
        <v-card color="whitesmoke" class="mb-4 pa-4 volunteer-step1-card">
          <v-select
            attach
            v-model="form.positionPreference"
            :items="positionItems"
            label="Preferred Volunteer Area*"
            :rules="reqRules"
            :menu-props="{ contentClass: 'volunteer-menu' }"
          ></v-select>
        </v-card>

        <v-btn color="primary" @click="update(2)">Continue</v-btn>
        <v-btn text @click="cancel">Cancel</v-btn>
      </v-stepper-content>

      <!-- STEP 2 -->
      <v-stepper-step :complete="stepcount > 2" step="2">
        Contact Information
      </v-stepper-step>

      <v-stepper-content step="2" class="pa-0">
        <v-card color="whitesmoke" class="mb-4 pa-4 volunteer-contact-card">
          <v-form ref="contactForm" v-model="valid" lazy-validation>
            <v-row no-gutters>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.name"
                  label="Name*"
                  :rules="nameRules"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.email"
                  label="Email*"
                  :rules="emailRules"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="form.address"
                  label="Address*"
                  :rules="reqRules"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.city"
                  label="City*"
                  :rules="reqRules"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.state"
                  label="State*"
                  :rules="reqRules"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.zip"
                  label="Zip*"
                  :rules="reqRules"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.phone"
                  label="Phone*"
                  :rules="phoneRules"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card>

        <v-btn color="primary" @click="update(3)">Continue</v-btn>
        <v-btn color="primary" class="ml-2" @click="stepcount = 1">Back</v-btn>
        <v-btn text @click="cancel">Cancel</v-btn>
      </v-stepper-content>

      <!-- STEP 3 -->
      <v-stepper-step :complete="stepcount > 3" step="3">
        Event Information
      </v-stepper-step>

      <v-stepper-content step="3" class="pa-0">
        <v-card color="whitesmoke" class="mb-4 pa-4 volunteer-step3-card">
          <v-select
            attach
            v-model="form.hear"
            :items="hearItems"
            label="How did you hear about our event?*"
            :rules="reqRules"
            :menu-props="{ contentClass: 'volunteer-menu' }"
          ></v-select>

          <v-text-field
            v-if="form.hear === 'Other'"
            v-model="form.hearOther"
            label="Please specify*"
            :rules="otherHearRules"
          ></v-text-field>
        </v-card>

        <v-card color="whitesmoke" class="mb-4 pa-4">
          <p>
            There will be a brief 1-hour training meeting 1–2 weeks prior to the event.
            We will contact you with details as the event approaches.
          </p>

          <p>
            If you do not receive confirmation within 7 days, please contact:
            <strong>13soulsrun@gmail.com</strong>
          </p>

          <p><strong>Thank you for volunteering.</strong></p>
        </v-card>
<div class="pb-4">
        <v-btn color="primary" @click="finish">Submit</v-btn>
        <v-btn color="primary" class="ml-2" @click="stepcount = 2">Back</v-btn>
        <v-btn text @click="cancel">Cancel</v-btn>
        </div>
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>
import { bus_common } from "../mixins/bus_common";

export default {
  name: "volunteer_register",
  mixins: [bus_common],

  data() {
    return {
      valid: true,
      stepcount: 1,

      reqRules: [
        (v) => !!v || "Required"
      ],
      nameRules: [
        (v) => !!v || "Name required"
      ],
      emailRules: [
        (v) => !!v || "Email required",
        (v) => /.+@.+\..+/.test(v) || "Invalid email"
      ],
      phoneRules: [
        (v) => !!v || "Phone required"
      ],

      positionItems: [
        "Parking",
        "Registration/Check-in",
        "Course Set-up",
        "Vendor set-up / tear down",
        "Starting Line / Finish Line",
        "Ceremony",
        "On-Course Assistance",
        "Merchandise Booth",
        "Open to wherever placed"
      ],

      hearItems: [
        "Yard Sign",
        "Newspaper",
        "Word of Mouth",
        "Banner",
        "Family/Friend",
        "Flyer",
        "Past Participant Email",
        "Social Media",
        "Other"
      ],

      form: {
        volunId: 0,
        positionPreference: "",
        name: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        email: "",
        phone: "",
        hear: "",
        hearOther: ""
      },

      form_dev: {
        volunId: 0,
        positionPreference: "Registration/Check-in",
        name: "Jeff Von Molt",
        address: "123 Main Street",
        city: "Reno",
        state: "NV",
        zip: "89501",
        email: "jvonmolt@gmail.com",
        phone: "111-111-1111",
        hear: "Social Media",
        hearOther: ""
      }
    };
  },

  computed: {
    otherHearRules() {
      return this.form.hear === "Other"
        ? [(v) => !!v || "Please specify"]
        : [];
    }
  },

  methods: {
    fillDev() {
      const id = this.form.volunId;
      this.form = { ...this.form, ...this.form_dev };
      this.form.volunId = id;
    },

    cancel() {
      this.$router.push("/");
    },

    create_min_record() {
      const formIn = {
        fields: this.form,
        apiname: "create_min_record_vol"
      };

      this.$store.dispatch("anyapi", formIn).then((data) => {
        this.form = this.mno(data);
        this.$store.commit("setVolunId", this.form.volunId);

        this.show_loader(false);
      });
    },

    update(step) {
      if (step === 3) {
        const valid = this.$refs.contactForm.validate();
        if (!valid) {
          this.swall_it(
            "Form Entry Status",
            "Please address the required fields before continuing.",
            "error",
            null,
            null
          );
          return;
        }
      }

      const formIn = {
        fields: this.form,
        apiname: "update_record_vol"
      };

      this.$store.dispatch("anyapi", formIn).then((data) => {
        this.form = this.mno(data);
        this.stepcount = step;
      });
    },

    finish() {
      if (!this.form.hear) {
        this.swall_it(
          "Form Entry Status",
          "Please complete the event information before submitting.",
          "error",
          null,
          null
        );
        return;
      }

      if (this.form.hear === "Other" && !this.form.hearOther) {
        this.swall_it(
          "Form Entry Status",
          "Please specify how you heard about the event.",
          "error",
          null,
          null
        );
        return;
      }

      const formIn = {
        fields: this.form,
        apiname: "update_record_vol"
      };

      this.$store.dispatch("anyapi", formIn).then((data) => {
        this.form = this.mno(data);
        this.swall_it("Success", "Thank you for volunteering!", "success");
        this.$router.push("/");
      });
    },

    init() {
      if (this.$store.state.volunId == -1) {
        this.create_min_record();
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  }
};
</script>

<style scoped>
#reg-container {
  max-width: 768px;
  min-height: 50dvh;
  overflow-x: hidden;
}

.volunteer-stepper {
  max-width: 100%;
  overflow-x: hidden;
}

.volunteer-step1-card {
  min-height: 380px;
}

.volunteer-step3-card {
  min-height: 320px;
}

:deep(.volunteer-menu) {
  max-width: calc(100vw - 32px) !important;
}

:deep(.volunteer-menu .v-list-item),
:deep(.volunteer-menu .v-list-item__title) {
  white-space: normal !important;
}

:deep(.v-stepper__content) {
  margin: -8px 0 -16px 0 !important;
  padding: 5px !important;
}
</style>